export default __webpack_public_path__ + "static/media/hurry_up_4.1f1fa33d.gif";